import React, { useEffect, useState } from 'react';
import { updateGDPR } from './data/data-service';
import { getCookie } from '../../DAL/storage-provider';
import GDPRWidget from "./gdpr-widget/gdpr-widget";
import { sendGAEvent } from '../../domain/marketing/gtm-provider';
import { GDRP_COOKIE_NAME, getGdprCookieFromServer, setGDPRCookie } from './domain/gdpr-provider';
import { getHiddenDataString, getIsAuthenticated } from '../../domain/hidden-data-provider';
import GDPRWidgetLawyer from './gdpr-widget/gdpr-widget-lawyer';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-1833
 */
const GDPR = () => {
    const gdprCookieFromServer = getGdprCookieFromServer();
    const cookie = getCookie(GDRP_COOKIE_NAME);
    const isUserLoggedIn = getIsAuthenticated();

    const [isShowWidget, setIsShowWidget] = useState(false);
    const [isLawyerWidget, setIsLawyerWidget] = useState(false);

    const showWidget = () => {
        setIsShowWidget(true);
        sendGAEvent('Consent Widget','Widget Displayed');
    };

    useEffect(() => {

        (async ()=> {
            if(cookie) {

                // Don't show widget if there is a client-side cookie.
                setIsShowWidget(false);

                if(isUserLoggedIn) {
                    if(gdprCookieFromServer) {

                        // We have cookie in client side and cookie from server,
                        // and the user is logged in.
                        // Update client side cookie with server cookie.
                        setGDPRCookie(gdprCookieFromServer);
                    }
                    else{
                        // We have a cookie in client side, but don't have the
                        // server side cookie, and the user is logged in.
                        // Update database with the cookie.
                        await updateGDPR();
                    }
                }
            }
            else{
                // NO COOKIE -----------------------
                if(isUserLoggedIn) {
                    if(gdprCookieFromServer) {

                        // We have cookie in client side and cookie from server,
                        // and the user is logged in.
                        // Update client side cookie with server cookie.
                        setGDPRCookie(gdprCookieFromServer);
                    }
                    else{
                        // https://wavesaudio.atlassian.net/browse/DSWEB-4435
                        const gdprCountryResult = getHiddenDataString('gdpr-country');
                        setIsLawyerWidget(gdprCountryResult === 'y');

                        // There is no both client-side and server-side cookies.
                        // We need to show the widget in this case.
                        showWidget();
                    }
                }
                else{
                    // https://wavesaudio.atlassian.net/browse/DSWEB-4435
                    const gdprCountryResult = getHiddenDataString('gdpr-country');
                    setIsLawyerWidget(gdprCountryResult === 'y');
                    // The user is not logged in, and we don't have client side cookie
                    // ---> show the widget.
                    showWidget();
                }
            }
        })();

    },[cookie, isUserLoggedIn, gdprCookieFromServer])

    return(
        <div>
            {
                isShowWidget && (
                    <>
                        { !isLawyerWidget && <GDPRWidget /> }
                        { isLawyerWidget && <GDPRWidgetLawyer /> }
                    </>
                )
            }
        </div>
    )
}

export default GDPR;